/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Method_Local_PickupInputs */

const en_delivery_method_local_pickup = /** @type {(inputs: Delivery_Method_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local Pickup`)
};

const es_delivery_method_local_pickup = /** @type {(inputs: Delivery_Method_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recogida local`)
};

/**
* | output |
* | --- |
* | "Local Pickup" |
*
* @param {Delivery_Method_Local_PickupInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const delivery_method_local_pickup = /** @type {((inputs?: Delivery_Method_Local_PickupInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Method_Local_PickupInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_method_local_pickup(inputs)
	return es_delivery_method_local_pickup(inputs)
});